import { useState, useCallback } from 'react';

export const useConfirmationModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [config, setConfig] = useState({
    title: 'Confirm Action',
    message: '',
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    type: 'warning',
    onConfirm: () => {},
    onCancel: () => {}
  });

  const showConfirmation = useCallback((options) => {
    setConfig({
      title: options.title || 'Confirm Action',
      message: options.message || '',
      confirmText: options.confirmText || 'Confirm',
      cancelText: options.cancelText || 'Cancel',
      type: options.type || 'warning',
      onConfirm: options.onConfirm || (() => {}),
      onCancel: options.onCancel || (() => {})
    });
    setIsVisible(true);
  }, []);

  const hideConfirmation = useCallback(() => {
    setIsVisible(false);
  }, []);

  const handleConfirm = useCallback(() => {
    config.onConfirm();
    hideConfirmation();
  }, [config, hideConfirmation]);

  const handleCancel = useCallback(() => {
    config.onCancel();
    hideConfirmation();
  }, [config, hideConfirmation]);

  return {
    isVisible,
    config,
    showConfirmation,
    hideConfirmation,
    handleConfirm,
    handleCancel
  };
};

export default useConfirmationModal;
